import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { FixedBoxTitle } from "pro-features/components/BoxTitle/src/FixedBoxTitle";
import { translate } from "app/filters/i18nFilter";
import { useCurrentStateAndParams } from "@uirouter/react";
import type { IDurationData } from "app/services/DurationService";
import DurationService from "app/services/DurationService";
import type { FC } from "react";
import { CHART_COLORS } from "app/constants/ChartColors";
import { PeriodOverPeriodItem } from "app/pages/industry-analysis/common/styledComponents";

const Title = () => {
    return (
        <FixedBoxTitle
            title={translate("pre.defined.industries.table.header.title")}
            tooltip={translate("pre.defined.industries.table.header.title.tooltip")}
        />
    );
};

const PeriodOverPeriodSubtitle: FC<{ durationObject: IDurationData }> = ({ durationObject }) => {
    const { forWidget } = durationObject;
    if (!Array.isArray(forWidget)) {
        return null;
    }
    const [currentPeriod, previousPeriod] = forWidget;
    return (
        <FlexRow gap={"8px"}>
            <FlexRow gap={"4px"}>
                <PeriodOverPeriodItem
                    text={previousPeriod}
                    color={CHART_COLORS.periodOverPeriod.Total[1]}
                />
                <PeriodOverPeriodItem
                    text={currentPeriod}
                    color={CHART_COLORS.periodOverPeriod.Total[0]}
                />
            </FlexRow>
        </FlexRow>
    );
};
export const Header = () => {
    const { params } = useCurrentStateAndParams();
    const { duration, comparedDuration } = params;
    const isPeriodOverPeriod = Boolean(comparedDuration);
    const durationObject = DurationService.getDurationData(duration, comparedDuration);
    return isPeriodOverPeriod ? (
        <FlexColumn gap={"4px"}>
            <Title />
            <PeriodOverPeriodSubtitle durationObject={durationObject} />
        </FlexColumn>
    ) : (
        <FlexRow>
            <Title />
        </FlexRow>
    );
};
